<div
  [ngClass]="'skymiles-landing-page-cards__content__cards--' + contents.type"
>
  <div
    [ngClass]="[
      'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__element'
    ]"
  >
    <span
      *ngIf="
        contents.tag?.title && contents.id === 'skyClubMembershipCard';
        else medallionCard
      "
      [ngClass]="
        'skymiles-landing-page-cards__' + contents.type + '__sky-club-wrapper'
      "
    >
      <div class="skymiles-landing-page-cards__sky-club-wrapper">
        <div class="skymiles-landing-page-cards__sky-club-wrapper__box">
          <span class="skymiles-landing-page-cards__sky-club-wrapper__box__top">
            {{ contents.tag?.title }}
          </span>
          <span
            *ngIf="contents.tag?.subtitle"
            class="skymiles-landing-page-cards__sky-club-wrapper__box__bottom"
          >
            {{ contents.tag?.subtitle }}
          </span>
        </div>
      </div>
    </span>

    <ng-template #medallionCard>
      <span
        *ngIf="contents.tag?.title"
        [ngClass]="
          'skymiles-landing-page-cards__content__cards--' +
          contents.type +
          '__tag'
        "
      >
        {{ contents.tag?.title }}
        <div *ngIf="contents.tag?.subtitle">
          {{ contents.tag?.subtitle }}
        </div>
      </span>
    </ng-template>

    <img
      [alt]="contents.image.alt"
      [ngClass]="
        'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__img' +
        getImageClass()
      "
      [src]="contents.image.src"
    />
    <img
      *ngIf="contents.image2 && contents.image2.show"
      [alt]="contents.image2.alt"
      [ngClass]="
        'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__img2'
      "
      [src]="contents.image2.src"
    />
  </div>
  <div
    *ngIf="contents.action.type !== 'caret'"
    [ngClass]="[
      'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__links' +
        ' ' +
        getClassesForLinks(contents.type, contents.action.type)
    ]"
  >
    <div
      [ngClass]="
        'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__title'
      "
    >
      <span [attr.aria-hidden]="contents.image ? true : false">
        {{ contents.content.title }}
      </span>
      <br />
      <span>
        {{ contents.content.subtitle }}
      </span>
    </div>
    <idp-link
      *ngIf="contents.action.type === 'text'"
      [id]="contents.id || '#'"
      [axLabel]="contents.content.title + contents.action.link.label"
      [label]="contents.action.link.label"
      [actionUrl]="contents.action.link.url"
      [ngClass]="
        'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__links__' +
        contents.action.type
      "
    ></idp-link>
    <idp-link
      (click)="notifyParent()"
      *ngIf="contents.action.type === 'notify'"
      [id]="contents.id || '#'"
      [axLabel]="contents.content.title + contents.action.link.label"
      [label]="contents.action.link.label"
      [labelSize]="'extra-large'"
      [ngClass]="
        'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__links__' +
        contents.action.type
      "
    ></idp-link>
  </div>
  <div
    *ngIf="contents.action.type === 'caret'"
    [ngClass]="[
      'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__links' +
        ' ' +
        getClassesForLinks(contents.type, contents.action.type)
    ]"
  >
    <a
      [href]="contents.action.link.url"
      target="_blank"
      [id]="contents.id || '#'"
      [ngClass]="
        'skymiles-landing-page-cards__content__cards--' +
        contents.type +
        '__url'
      "
    >
      <div
        [ngClass]="
          'skymiles-landing-page-cards__content__cards--' +
          contents.type +
          '__title'
        "
      >
        <span [attr.aria-hidden]="contents.image ? true : false">
          {{ contents.content.title }}
        </span>
        <br />
        <span>
          {{ contents.content.subtitle }}
        </span>
      </div>
      <div
        [ngClass]="
          'skymiles-landing-page-cards__content__cards--' +
          contents.type +
          '__links__' +
          contents.action.type
        "
      ></div>
      <span class="sr-only">
        {{ contents.action.link.label }} opens in a new tab
      </span>
    </a>
  </div>
</div>
